import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_item",
  "use": "icon-project_item-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_item\"><g transform=\"translate(1 1)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"1\" y=\"1\" width=\"10\" height=\"10\" rx=\"2\" /><rect x=\"15\" y=\"1\" width=\"10\" height=\"10\" rx=\"2\" /><rect x=\"1\" y=\"15\" width=\"10\" height=\"10\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M20 16v8M16 20h8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol